import listActions from 'src/modules/recurso/list/recursoListActions';
import RecursoService from 'src/modules/recurso/recursoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'RECURSO_DESTROY';

const recursoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: recursoDestroyActions.DESTROY_STARTED,
      });

      await RecursoService.destroyAll([id]);

      dispatch({
        type: recursoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.recurso.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/recurso');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: recursoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: recursoDestroyActions.DESTROY_ALL_STARTED,
      });

      await RecursoService.destroyAll(ids);

      dispatch({
        type: recursoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.recurso.destroyAll.success'),
      );

      getHistory().push('/recurso');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: recursoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default recursoDestroyActions;
